import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class AutomatKindService extends HeaderService {

  getAutomatKinds(): Observable<any> {
    return this.http.get(environment.apiBaseUrl + 'automat-kinds/',
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }
  createAutomatKind(data): Observable<any> {
    return this.http.post(environment.apiBaseUrl + 'automat-kind',
        JSON.stringify(data),
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }
  updateAutomatKind(data, id): Observable<any> {
    return this.http.put(environment.apiBaseUrl + 'automat-kind/' + id,
        JSON.stringify(data),
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }
  deleteAutomatKind(id): Observable<any> {
    return this.http.delete(environment.apiBaseUrl + 'automat-kind/' + id,
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }
  getAutomatKind(id): Observable<any> {
    return this.http.get(environment.apiBaseUrl + 'automat-kind/' + id,
        this.httpBearerOptions)
        .map((response: Response) => {
          return response;
        })
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/automat-kind.service.ts